import React from 'react';
import {Button, Grid, Input, Modal} from 'semantic-ui-react';
import _ from 'lodash'
import {socket} from "../../../lib/socketio";
import {isAuthorized} from "../../../lib/authorization";
import {useSelector} from "react-redux";
import { createUserLog } from '../../../lib/api';

const ControlGroupColumn = ({ index, column, data, property, maxArr, minArr }) => {

    const [tagdata, settagdata]= React.useState('');
    const [checkdata, setcheckdata]= React.useState('');
    const [open, setOpen] = React.useState(false);
    const [dataCopy, setDataCopy] = React.useState();
    const [isCopied, setIsCopied] = React.useState(false);
    const [isValidationError, setIsValidationError] = React.useState(false);
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);
    const [log, setLog]= React.useState('');

    React.useEffect(() => {
        if(Object.keys(data).length !== 0 && !isCopied){
            setDataCopy({...data});
            setIsCopied(true)
        }
    }, [data]);

    const handleOpen = (id) => setOpen({...open, [id]: true});

    const handleClose = (id) => {
        setIsValidationError(false);
        settagdata('');
        setcheckdata('');
        setOpen({...open, [id]:false});
    };

    const handleSubmit = (event, id) => {
        event.preventDefault();
        if(typeof tagdata === 'undefined' || tagdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            var writedata = [{'tag_id': id, 'tag_value': tagdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]:false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }
        settagdata('');
    }

    const handleChange = (event, value, id, min, max, display_id) => {
        event.preventDefault();
        if(event.target.value < min || event.target.value > max){
            setIsValidationError(true);
        }
        else {
            setIsValidationError(false);
            settagdata(event.target.value);
            if (!electronApp) {
                setLog({
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: display_id,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({ tag_id: [id] }),
                });
            }
        }

    }

    const getlabel1 = (name, id) => {
        // if(id === 6890 || id === 6907 || id === 5714 || name.slice(5,9) === 'OPT_') // PAFC : CL_ERFB_LATCH_CLEAR, CL_LT400B_LATCH_CLEAR, CL110_PIRESET
        //     return 'Enable'
        if(name.slice(5,9) === 'OPT_') // PAFC : CL_ERFB_LATCH_CLEAR, CL_LT400B_LATCH_CLEAR, CL110_PIRESET
            return 'Enable'
        else return '1.0 Sec'
    }

    const getlabel2 = (name, id) => {
        // if(id === 6890 || id === 6907 || id === 5714 || name.slice(5,9) === 'OPT_')
        //     return 'Disable'
        if(name.slice(5,9) === 'OPT_')
            return 'Disable'
        else return '0.5 Sec'
    }

    const getValue = (parm,name,id) => {

        if(parm === 1) {
            // if(id === 6907 || id === 6890 || id === 5714 || name.slice(5,9) === 'OPT_'){
            //     return 'Enable'
            // }
            if(name.slice(5,9) === 'OPT_'){
                return 'Enable'
            }
            else{
                return '1.0 SEC'
            }
        }
        else {
            // if(id === 6907 || id === 6890 ||id === 5714 || name.slice(5,9) === 'OPT_'){
            //     return 'Disable'
            // }
            if(name.slice(5,9) === 'OPT_'){
                return 'Disable'
            }
            else{
                return '0.5 SEC'
            }
        }
    };

    const handleCheck = (event, obj_key, display_id) => {
        if( event.target.id === "1") {
            setcheckdata(1);
            setDataCopy({...dataCopy, [obj_key]: 1});
            if (!electronApp) {
                setLog({
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: display_id,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({ tag_id: [obj_key] }),
                });
            }
        }
        else if( event.target.id === "0"){
            setcheckdata(0);
            setDataCopy({...dataCopy, [obj_key]: 0});
            if (!electronApp) {
                setLog({
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: display_id,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({ tag_id: [obj_key] }),
                });
            }
        }
    }

    const handleToggle = (event, id) => {
        event.preventDefault();
        if(typeof checkdata === 'undefined' || checkdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            var writedata = [{'tag_id': id, 'tag_value': checkdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]:false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }

    }

    const getDecimal = (id) => {
        if(id === 29878 || id === 31285 || id === 32692 || id === 34099 || id === 35506
            || id === 29880 || id === 31287 || id === 32694 || id === 34101 || id === 35508
        ){ // PAFC : CL110_KP, CL110_DENSCONST, CAL_PDT012_GAIN, 
            return '0.000001'; // 6 decimals
        }
        // else if(id ===9999){ // PSM1_CL110_PI02_KP
        //     return '0.0000001'; // 7 decimals
        // }
        else return '0.0001'; // 4 decimals
    }

   const gridColumn = _.times((1), (i) => (
        Object.keys(column).map(i => (
            <Grid columns = 'equal' style={styles.grid}>
                {property === 1 ?
                    <p style={{fontWeight: 'bold'}}> {column[i][0].hmi_controlloop_subdisplay} </p> 
                    :
                    property === 4 ? <p style={{fontWeight: 'bold'}}>{(typeof column[i][0].tag_display_subgroup !== 'undefined' && column[i][0].tag_display_subgroup !== '' && column[i][0].tag_display_subgroup !== null) ? column[i][0].tag_display_subgroup : column[i][0].hmi_controlloop_subdisplay}</p>
                    :
                    column[i][0].tag_display_name === 'N/A' ?
                    <>
                    </>
                    :
                    <p style={{fontWeight: 'bold'}}>{column[i][0].tag_display_subgroup} </p>
                }
                        {column[i].map(r =>
                            <Grid.Row style={{padding: '1.5px 0'}}>
                                <Grid.Column width ='10' style={styles.name}>{r.tag_display_name} </Grid.Column>
                                <Grid.Column style={{color: '#04bfbf', fontWeight: 'bold'}}>
                                    {r.canHMIWrite === 0  ? // DINFS400_VALUE, AINLT400_VALUE
                                        <>
                                            <Button
                                                key='button'
                                                size='tiny'
                                                disabled
                                                content={data[r.id]}/>
                                            <Modal></Modal>{r.unit}
                                        </>
                                        : r.name.slice(5,9) === 'OPT_'?
                                        <>
                                            <Button
                                                key = 'button'
                                                disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                                content = {getValue(data[r.id],r.tag_display_name,r.id)}
                                                inverted color = {data[r.id] === 1 ? 'green' : 'yellow'}
                                                onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                            <Modal
                                                key = {r.id}
                                                style = {styles.width}
                                                open = {open[r.id]}
                                                onClose={handleClose[r.id]}
                                                onOpen = {handleOpen[r.id]}>
                                                <Modal.Header>Select Choice for {r.tag_display_name} </Modal.Header>
                                                <Modal.Content>
                                                    <Input
                                                        type='radio'
                                                        id={1}
                                                        label={getlabel1(r.name,r.id)}
                                                        checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 1 : ''}
                                                        onChange={(event, value) => handleCheck(event,r.id,r.display_id)}
                                                        style={styles.checkbox1}
                                                        />
                                                    <Input
                                                        type='radio'
                                                        id={0}
                                                        label={getlabel2(r.name,r.id)}
                                                        checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 0 : ''}
                                                        onChange={(event, value) => handleCheck(event,r.id,r.display_id)}
                                                        style={styles.checkbox1}
                                                        />
                                                </Modal.Content>
                                                <Modal.Actions style={styles.toggle}>
                                                    <Button color='blue' content={'Ok'}
                                                        onClick={(event, value) => handleToggle(event,r.id)}/>
                                                    <Button color='red' content={'Cancel'}
                                                        onClick={  () => handleClose(r.id)}/>
                                                </Modal.Actions>
                                            </Modal>
                                        </>
                                        :
                                        <>
                                        <Button
                                            key = 'button'
                                            type = 'button'
                                            size='tiny'
                                            disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                            content = {data[r.id]}
                                            // content = {getDecimalValue(r.id)}
                                            onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                        <Modal
                                               key = {r.id}
                                               style = {styles.width}
                                               open = {open[r.id]}
                                               onClose={handleClose[r.id]}
                                               onOpen={handleOpen[r.id]}>
                                            <Modal.Header>Enter Value for {r.name}</Modal.Header>
                                            <Modal.Content>
                                                <form  style = {styles.form} autoComplete='off' onSubmit={(event, value) => handleSubmit(event, r.id)}>
                                                    <Input focus placeholder='Value'
                                                           name='Input change'
                                                           label = {r.unit || ""}
                                                           labelPosition='right'
                                                           type='number'
                                                           step ={getDecimal(r.id)}
                                                           size='small'
                                                           autoFocus
                                                           min ={r.min}
                                                           max ={r.max}
                                                           error={isValidationError}
                                                           onChange={(event, value) => handleChange(event, value, r.id, r.min, r.max, r.display_id)}
                                                           defaultValue={data[r.id]}
                                                    />
                                                </form>
                                            </Modal.Content>
                                            <Modal.Actions>
                                                <Button color='blue' content={'Ok'} disabled={isValidationError} onClick={(event, value) => handleSubmit(event, r.id)}/>
                                                <Button
                                                    key = 'button'
                                                    content = 'Close'
                                                    color = 'red'
                                                    style={{marginLeft: '5px', marginTop: '10px'}}
                                                    onClick ={  () => handleClose(r.id)}/>
                                            </Modal.Actions>
                                        </Modal> {r.unit}
                                        </>
                                    }
                                </Grid.Column>
                            </Grid.Row>
                        )}
            </Grid>
            ))
    ))

    return (
        <Grid.Column key={index} style={{ maxWidth: '500px', padding: '10'}}>
                    {gridColumn}
        </Grid.Column>
    );
};

const styles = {
    grid: {
        margin: '0'
    },
    width: {
        maxWidth: '400px'
    },
    name: {
        color: 'yellow',
        fontWeight: 'bold',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word'
    },
    form: {
        padding: '10px'
    },
    checkbox1: {
        flexDirection: 'row-reverse',
    }
};

export default React.memo(ControlGroupColumn);

